/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with notebooks, markers and folders. If the quantities are 12, 3 and 12, and the unit costs are 4, 6 and 2, the line totals should be 48, 18 and 24. The combined amount is 90. Enter the formulas shown below, then increase the notebook quantity from 12 to 15. The notebook total becomes 60 and the combined amount becomes 102. Those expected results give you a simple check.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以笔记本、记号笔和文件夹为例，数量分别为 12、3 和 12，单价分别为 4、6 和 2，对应金额应为 48、18 和 24，总计为 90。输入下方公式，再将笔记本数量从 12 改为 15，笔记本金额应变为 60，总计为 102。这些预期结果可用于简单核对。`)
};

/**
* | output |
* | --- |
* | "Start with notebooks, markers and folders. If the quantities are 12, 3 and 12, and the unit costs are 4, 6 and 2, the line totals should be 48, 18 and 24. Th..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_5_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_5_paragraphs_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_5_paragraphs_1 as "gc.search_guides.what_is_gridcraft.sections.5.paragraphs.1" }